"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionList = void 0;
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var collection_card_1 = require("./collection.card");
var collection_list_style_1 = require("./collection.list.style");
(0, theme_1.addStyles)(collection_list_style_1.Style);
exports.CollectionList = {
    view: function (state, tag, collectionSummaries) {
        var collectionCards = [];
        for (var _i = 0, collectionSummaries_1 = collectionSummaries; _i < collectionSummaries_1.length; _i++) {
            var collectionSummary = collectionSummaries_1[_i];
            var summaryView = collection_card_1.CollectionCard.view(state, tag, collectionSummary);
            collectionCards.push(summaryView);
        }
        return (0, mithril_1.m)('div', { className: collection_list_style_1.CSS.container, key: 'cl-' + tag.objectId }, collectionCards);
    },
    viewLoading: function (tagId) {
        return (0, mithril_1.m)('div', { className: "".concat(collection_list_style_1.CSS.container, " ").concat(collection_list_style_1.CSS.loading), key: 'cl-' + tagId }, spinner_1.Spinner.view());
    }
};
//# sourceMappingURL=collection.list.js.map